import { actions } from '../constants'

export const initial = {
  src: '',
  error: '',
}

export default function (state = initial, { type, payload }) {
  switch (type) {
    case actions.FETCH_FILE_SUCCESS:
      return {
        src: payload.src,
        contentType: payload.contentType,
      }

    case actions.FETCH_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
      }

    case actions.CLEAR_ERRORS:
      return {
        ...state,
        error: '',
      }

    default:
      return state
  }
}
